import { rowsType } from '.'

export const mountSectionInfo = (
    section: Section,
    wellIndex: number
): {
    wellIndex: number
    type: RowType
    name: string
    begin: string
    end: string
} => {
    const sectionInfo = {
        wellIndex: wellIndex,
        type: rowsType[1],
        name: section?.name || 'SECTION',
        begin: Math.min(...section?.runs?.map(r => r?.start))?.toString(),
        end: Math.max(...section?.runs?.map(r => r?.end ?? new Date().getTime()))?.toString()
    }

    return sectionInfo
}
